import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { DEFAULT_TRACKING_CONFIG, type TrackingConfig } from "@/lib/tracking";

// Deep-merges a stored (possibly partial) config onto the defaults so older or
// incomplete rows never crash the tracking engine.
function mergeConfig(value: unknown): TrackingConfig {
  const v = (value ?? {}) as Partial<TrackingConfig>;
  return {
    enabled: Boolean(v.enabled),
    consentBannerEnabled:
      v.consentBannerEnabled === undefined ? true : Boolean(v.consentBannerEnabled),
    google: { ...DEFAULT_TRACKING_CONFIG.google, ...(v.google ?? {}) },
    meta: { ...DEFAULT_TRACKING_CONFIG.meta, ...(v.meta ?? {}) },
    linkedin: { ...DEFAULT_TRACKING_CONFIG.linkedin, ...(v.linkedin ?? {}) },
  };
}

export function useTrackingConfig() {
  return useQuery({
    queryKey: ["tracking-config"],
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<TrackingConfig> => {
      const { data, error } = await supabase
        .from("site_settings")
        .select("value")
        .eq("key", "tracking_config")
        .maybeSingle();
      if (error) throw error;
      return mergeConfig(data?.value);
    },
  });
}
